import { z } from 'zod';

// Legacy status-count endpoints return a map keyed by their serialized status.
export const statusCountsSchema = z.record(z.string(), z.number().int().nonnegative());
export type StatusCounts = z.infer<typeof statusCountsSchema>;
